import React from 'react';
import { Button, Menu } from '@fragments';
import { IconDownload, IconDeviceDesktop, IconDeviceMobile, IconCopy } from '@tabler/icons-react';
import useScriptActions from './hooks/useScriptActions';
import memoStudio from '../../../../utils/memoStudio';

function ScriptActions({ studio: s, revision, onTeleprompter, onMobile }) {
  const { t } = s;
  const { download, copy, openTeleprompter, openMobile } = useScriptActions(s, onTeleprompter, onMobile, revision);
  return <><div className="studio-row"><Menu items={[{ label: 'PDF', onClick: () => download('pdf') }, { label: 'DOCX', onClick: () => download('docx') }]}><Button color="overlay" startIcon={<IconDownload />} dropdown>{t('download')}</Button></Menu><Button color="overlay" variant="text" icon={<IconCopy />} aria-label={t('copy')} onClick={copy} /></div><div className="studio-row"><Button startIcon={<IconDeviceDesktop />} onClick={openTeleprompter}>{t('teleprompter')}</Button><Button variant="text" color="overlay" icon={<IconDeviceMobile />} aria-label={t('mobile')} onClick={openMobile} /></div></>;
}

// Every `studio` field the actions (useScriptActions) read.
export default memoStudio(ScriptActions, ['t', 'exportScript', 'savedRevision', 'setError']);
